import Chip from "@mui/material/Chip";
import { Group } from "../../api/person/groups";

interface GroupChipProps {
	group: Group;
	size?: "small" | "medium";
	variant?: "filled" | "outlined";
}

export const GroupChip = ({
	group,
	size = "small",
	variant = "outlined",
}: GroupChipProps) => {
	return (
		<Chip
			key={group.id}
			label={group.name}
			component="a"
			href={group.url || undefined}
			target="_blank"
			rel="noopener noreferrer"
			clickable={!!group.url}
			variant={variant}
			size={size}
			data-component="group-chip"
			sx={{
				maxWidth: "300px",
				"& .MuiChip-label": {
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				},
			}}
		/>
	);
};
